<h2>
  {{ "participantSelect.title" | translate }}
</h2>
<mat-dialog-content>
  <mat-form-field class="searchField" appearance="outline">
    <input
      matInput
      autocomplete="off"
      type="text"
      placeholder="Search by name"
      [(ngModel)]="search"
      />
  </mat-form-field>
  @if ((allMembers$ | async)?.length > 0) {
    <div
      class="flex flex-col"
      >
      @if (filteredMembers$ | async; as filteredMembers) {
        @for (row of filteredMembers; track trackByMemberId($index, row)) {
          <div
            matRipple
            class="item flex flex-row justify-start items-center"
        [matRippleDisabled]="
          (currentUser$ | async)?.id === row.id || disabledIds?.includes(row.id)
        "
        [class.disabled]="
          (currentUser$ | async)?.id === row.id || disabledIds?.includes(row.id)
        "
            [class.selected]="selectedIds?.includes(row.id)"
            (click)="disabledIds?.includes(row.id) ? null : toggle(row)"
            >
            <div class="avatar">
              <ca-avatar
                [fullName]="row | displayname"
                [image]="row.profileImage | filedownloadurl | async"
                >
              </ca-avatar>
            </div>
            <div class="member-name">
              <h3>{{ row | displayname }}</h3>
              @if (!!row?.permissions?.length) {
                <p>
                  {{ (row?.permissions || [])[0]?.role | role }}
                </p>
              }
            </div>
          </div>
        }
      }
    </div>
  } @else {
    <p>
      {{ "participantSelect.empty" | translate }}
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w-full flex flex-col">
    <div class="w-full flex flex-row">
      <div class="host flex flex-col">
        <div>{{ "participantSelect.host" | translate }}</div>
        <ca-avatar-stack
          item-start
          [maxAvatars]="1"
          [avatars]="[currentUser$ | async] | avatars | async"
        ></ca-avatar-stack>
      </div>
      <div class="flex-grow flex flex-col">
        <div class="flex flex-row">
          {{ "participantSelect.participants" | translate }}
          ({{ selectedIds?.length || "0" }})
          <hr />
        </div>
        <ca-avatar-stack
          item-start
          [maxAvatars]="3"
          [avatars]="selectedMembers | avatars | async"
        ></ca-avatar-stack>
      </div>
    </div>
    <div class="flex flex-row justify-end items-center">
      <button ca-action-button [mat-dialog-close]="selectedIds">
        {{ "participantSelect.done" | translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
